export default __webpack_public_path__ + "static/media/portrait.59c56b91.png";